/* tslint:disable */
import { Observable } from 'rxjs';
import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';

import {
  BaseApiClient,
  RequestContext,
  ApiConfigManager,
  HttpRequestState,
} from '@sg/api/base-api-lib';
import { CountriesApiConfig } from '../api-config';

import { CountriesApi } from '../models';

@Injectable()
export class CountriesApiClient extends BaseApiClient<CountriesApiConfig> {
  constructor(httpClient: HttpClient, config: ApiConfigManager) {
    super(httpClient, config.countriesApiConfig);
  }

  countriesControllerPostCountriesSearch(
    params?: { body?: CountriesApi.GetCountriesRequest; xSgUser?: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<Array<CountriesApi.CountryDto>>;
  countriesControllerPostCountriesSearch(
    params?: { body?: CountriesApi.GetCountriesRequest; xSgUser?: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<Array<CountriesApi.CountryDto>>>;
  countriesControllerPostCountriesSearch(
    params?: { body?: CountriesApi.GetCountriesRequest; xSgUser?: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<Array<CountriesApi.CountryDto>>;
  countriesControllerPostCountriesSearch(
    params?: { body?: CountriesApi.GetCountriesRequest; xSgUser?: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<Array<CountriesApi.CountryDto>>>;
  countriesControllerPostCountriesSearch(
    params?: { body?: CountriesApi.GetCountriesRequest; xSgUser?: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<Array<CountriesApi.CountryDto>>>;
  countriesControllerPostCountriesSearch(
    params?: { body?: CountriesApi.GetCountriesRequest; xSgUser?: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<Array<CountriesApi.CountryDto>>>;
  countriesControllerPostCountriesSearch(
    params?: { body?: CountriesApi.GetCountriesRequest; xSgUser?: string },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<Array<CountriesApi.CountryDto>>(
      `${this.basePath}/gateway/admin/countries/search`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  countriesControllerGetCountriesTimezones(
    xSgUser?: string,

    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<Array<string>>;
  countriesControllerGetCountriesTimezones(
    xSgUser?: string,

    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<Array<string>>>;
  countriesControllerGetCountriesTimezones(
    xSgUser?: string,

    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<Array<string>>;
  countriesControllerGetCountriesTimezones(
    xSgUser?: string,

    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<Array<string>>>;
  countriesControllerGetCountriesTimezones(
    xSgUser?: string,

    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<Array<string>>>;
  countriesControllerGetCountriesTimezones(
    xSgUser?: string,

    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<Array<string>>>;
  countriesControllerGetCountriesTimezones(
    xSgUser?: string,

    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    requestContext.headers = this.createHeaders(options.headers || {}, ['x-sg-user', xSgUser]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<Array<string>>(
      `${this.basePath}/gateway/admin/countries/timezones`,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }
}
